import { Box, Typography, Button } from "@mui/material";
import Breadcrumbs from "components/common/Breadcrumbs";
import { ArrowBack } from "@mui/icons-material";
import theme from "lib/theme";
import { Link as RouterLink, Outlet, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";

function AssetsDetails() {
  let location = useLocation();
  let navigate = useNavigate();
  let [, uuid, path] = location.pathname.split("/").filter(Boolean);

  return (
    <div>
      <Box>
        <Breadcrumbs
          data={[
            { label: "Dashboard", to: "/" },
            { label: "Assets", to: "/assets" },
            {
              label: {
                history: "History",
                retrieve: "Remote Asset Return",
                checkout: "Check Out Asset",
              }[path],
            },
          ]}
        ></Breadcrumbs>
      </Box>

      <Box mt={4} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Box>
          <Typography variant="h4" fontWeight="bold">
            Asset History
          </Typography>

          {path === "checkout" ? (
            <Button sx={{ mt: 4.5 }} startIcon={<ArrowBack />} component={RouterLink} to={`/assets/${uuid}/details`}>
              back to Asset details
            </Button>
          ) : (
            <Button sx={{ mt: 4.5 }} startIcon={<ArrowBack />} onClick={() => navigate(-1)}>
              back to assets
            </Button>
          )}
        </Box>

        <Box
          sx={{
            [theme.breakpoints.down("sm")]: {
              display: "none",
            },
          }}
        >
          {" "}
        </Box>
      </Box>

      <Box
        mt={2}
        sx={{
          p: 4,
          background: "white",
          borderRadius: 1,
          border: `1px solid ${theme.palette.divider}`,
          [theme.breakpoints.down("md")]: {
            p: 2,
          },
        }}
      >
        <Outlet />
      </Box>
    </div>
  );
}

export default AssetsDetails;
